import CapegoIntegrationSettings from "./CapegoIntegrationSettings.js";
import Model from "../Model.js";

/**
 * AgencyIntegrationSettings which includes all different settings for all different integrations (i.e: Capego integration)
 *
 * @param {string} countryId - The ReferentialApi Id of the country owning the agency
 * @param {string} agencyId - The ReferentialApi Id of the agency
 * @param {CapegoIntegrationSettings} capegoIntegrationSettings - Capego integration settings which consist of an import mode, and office code
 */
export default class AgencyIntegrationSettings extends Model {
	constructor({
		countryId = "",
		agencyId = "",
		capegoIntegrationSettings = new CapegoIntegrationSettings(),
	} = {}) {
		super(...arguments);

		this._countryId = countryId;
		this._agencyId = agencyId;
		this._capegoIntegrationSettings = capegoIntegrationSettings;
	}

	setCountryId(value) {
		this._countryId = value;
	}

	setAgencyId(value) {
		this._agencyId = value;
	}

	getCapegoIntegrationSettings() {
		return this._capegoIntegrationSettings;
	}

	setCapegoIntegrationSettings(value) {
		this._capegoIntegrationSettings = value;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.countryId = this._countryId;
		properties.agencyId = this._agencyId;
		properties.capegoIntegrationSettings = this._capegoIntegrationSettings;

		return properties;
	}

	static transformMaterializationData(data) {
		data.capegoIntegrationSettings = CapegoIntegrationSettings.materialize(
			data.capegoIntegrationSettings,
		);
	}
}
